import { dropRight, isEqual } from 'lodash-es'
import { useRef } from 'react'
import { useDrag, useDrop } from 'react-dnd'

const type = Symbol('DraggableBodyRow')

const isDropAble = (task, dragTask) => {
  const curPath = dropRight(task.path || [])
  const dragPath = dropRight(dragTask.path || [])
  return isEqual(curPath, dragPath)
}

const DraggableBodyRow = (props: any) => {
  const { task = {}, moveRow, className, style, ...restProps } = props
  const ref = useRef<HTMLTableRowElement>(null)
  const [{ isOver, dropClassName }, drop] = useDrop({
    accept: type,
    collect: (monitor) => {
      const { task: dragTask = {} } = monitor.getItem() || {}
      if (dragTask.order === task.order) {
        return {}
      }
      const dropClassName = isDropAble(task, dragTask) ? ' drop-over-able' : ' drop-over-disable'
      return {
        isOver: monitor.isOver(),
        dropClassName
      }
    },
    drop: (item: any) => {
      const { task: dragTask = {} } = item
      if (!isDropAble(task, dragTask) || task.id === dragTask.id) {
        return
      }
      moveRow(dragTask.id, {
        oldOrder: dragTask.order,
        newOrder: task.order
      })
    }
  })

  const [, drag] = useDrag({
    item: { type, task },
    type,
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    })
  } as any)

  drop(drag(ref))

  return (
    <tr
      ref={ref}
      className={`${className}${isOver ? dropClassName : ''}`}
      style={{ cursor: 'move', ...style }}
      {...restProps}
    />
  )
}

export default DraggableBodyRow
